import styled from 'styled-components';
import H3 from '@sdk/components/ui/typography/H3';

export const Wrapper = styled.div`
  align-items: center;
  border-radius: 4px;
  display: flex;
  flex-flow: column nowrap;
  gap: 30px;
  overflow: hidden;
  padding-bottom: 40px;
  text-align: center;
  text-transform: none;
  width: 730px;
`;

export const Banner = styled.div<{ backgroundColor?: string }>`
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ? backgroundColor : theme.colors.bodyBg};
`;

export const Info = styled.div`
  padding: 0 75px;
`;

export const Title = styled(H3)`
  margin: 0;
  padding: 0 20px;
  text-align: inherit;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  font-weight: normal;
  margin: 20px 0 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 160px;
`;

export const Flag = styled.div`
  display: inline-block;
  vertical-align: middle;
  color: #ffffff;
  font-weight: bold;
  font-size: 11px;
  line-height: 14px;
  padding: 2px 8px;
  background-color: #1cc982;
  border-radius: 4px;
  margin-right: 12px;
  margin-top: -3px;
`;
